import { render, staticRenderFns } from "./ManageUser.vue?vue&type=template&id=68508872&"
import script from "./ManageUser.vue?vue&type=script&lang=js&"
export * from "./ManageUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports